


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { routes, getTitleFromRouteName } from '@/router';
import { Access } from '@/models';

@Component
export default class Menu extends Vue {
  @Getter('modules', { namespace: 'user' }) modules: Record<string, string>;
  get routes() {
    return routes.filter(({ root: { name } }) =>
      this.modules[name.slice(0, -4)]?.includes(Access.Read),
    );
  }
  // @ts-ignore
  getSubroutes(subRoutes) {
    // @ts-ignore
    return subRoutes.filter(({ name }) =>
      this.modules[name.slice(0, -4)]?.includes(Access.Read),
    );
  }
  get activeRouteName() {
    return getTitleFromRouteName(this.$route.name || '');
  }
}
